<div class="tool-content-container">
  <div class="tool-description">
    <!-- Select college, department,
    <instruction-step-link link="program" text="program" />, and click submit to
    view at-risk students. -->
    <!-- <b class="instructions-title">To view specific at-risk students:</b><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select College<br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select Department<br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select Program<br /><br /> -->

    <!-- <b class="warning-note"
      >*A student can only be added as an at-risk student from the
      <a routerLink="/student-profile">Student Profile</a> tool.</b
    ><br /><br /> -->

    <section *ngIf="atRiskStudentDataSource?.data?.length">
      <b class="reset-button-note"
        >*Reset button can be used to reset the filters.</b
      ><br />
      <b class="download-button-note"
        >*Download button can be used to download the results.</b
      >
    </section>
  </div>

  <div *ngIf="atRiskStudentDataSource?.data?.length; else noAtRiskStudents">
    <mat-form-field
      style="width: 15%; margin-right: 15px"
      appearance="fill"
      *ngFor="let filter of filterSelectObj"
    >
      <mat-label>Filter {{ filter.name }}</mat-label>
      <mat-select
        [(value)]="filter.defaultValue"
        (selectionChange)="filterChange($event, filter)"
        multiple
      >
        <mat-option
          *ngFor="let item of filter.options"
          [value]="item"
          #matOption
          >{{ item }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <a mat-fab extended style="margin-right: 15px" (click)="resetFilters()">
      <mat-icon>restart_alt</mat-icon>
      Reset
    </a>

    <a mat-fab extended color="primary" (click)="exportData()">
      <mat-icon>download</mat-icon>
      Download
    </a>

    <div class="mat-elevation-z8">
      <table
        mat-table
        [dataSource]="atRiskStudentDataSource"
        multiTemplateDataRows
      >
        <ng-container matColumnDef="uwf_id">
          <th mat-header-cell *matHeaderCellDef>UWF ID</th>
          <td mat-cell *matCellDef="let element">{{ element.uwf_id }}</td>
        </ng-container>

        <ng-container matColumnDef="gender">
          <th mat-header-cell *matHeaderCellDef>Gender</th>
          <td mat-cell *matCellDef="let element">{{ element.gender }}</td>
        </ng-container>

        <ng-container matColumnDef="cohort">
          <th mat-header-cell *matHeaderCellDef>Cohort</th>
          <td mat-cell *matCellDef="let element">{{ element.cohort }}</td>
        </ng-container>

        <ng-container matColumnDef="tier">
          <th mat-header-cell *matHeaderCellDef>Tier</th>
          <td mat-cell *matCellDef="let element">{{ element.tier }}</td>
        </ng-container>

        <ng-container matColumnDef="department">
          <th mat-header-cell *matHeaderCellDef>Department</th>
          <td mat-cell *matCellDef="let element">{{ element.department }}</td>
        </ng-container>

        <ng-container matColumnDef="program_cip_desc">
          <th mat-header-cell *matHeaderCellDef>Program</th>
          <td mat-cell *matCellDef="let element">
            {{ element.program_cip_desc }}
          </td>
        </ng-container>

        <ng-container matColumnDef="prob_apr_1st_term">
          <th mat-header-cell *matHeaderCellDef>APR 1st Term</th>
          <td mat-cell *matCellDef="let element">
            {{ convertToTwoDecimalPlaces(element.prob_apr_1st_term) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="uwf_gpa">
          <th mat-header-cell *matHeaderCellDef>UWF GPA</th>
          <td mat-cell *matCellDef="let element">{{ element.uwf_gpa }}</td>
        </ng-container>

        <ng-container matColumnDef="demo_time_frame">
          <th class="table-label" mat-header-cell *matHeaderCellDef>
            Time Frame
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.demo_time_frame }}
          </td>
        </ng-container>

        <ng-container matColumnDef="classification">
          <th class="table-label" mat-header-cell *matHeaderCellDef>
            Classification
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.classification }}
          </td>
        </ng-container>

        <ng-container matColumnDef="changed_program">
          <th class="table-label" mat-header-cell *matHeaderCellDef>
            Program Change
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.changed_program ? 'Yes' : 'No' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let element">
            <button
              class="delete-btn"
              (click)="deleteAtRiskStudent(element)"
              mat-icon-button
              aria-label="Delete at-risk student"
            >
              <mat-icon>delete_forever</mat-icon>
            </button>
            <button
              class="expand-btn"
              (click)="
                expandedElement = expandedElement === element ? null : element;
                setInnerTableDataSource()
              "
              mat-icon-button
              aria-label="expand comment table"
            >
              <mat-icon>{{
                expandedElement === element ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
          <td
            mat-cell
            *matCellDef="let element"
            [attr.colspan]="outerDisplayedColumns.length"
          >
            <div
              class="example-element-detail"
              [@detailExpand]="
                element == expandedElement ? 'expanded' : 'collapsed'
              "
            >
              <table
                mat-table
                [dataSource]="riskCommentsDataSource"
                class="mat-elevation-z8 inner-table"
              >
                <!-- Comment -->
                <ng-container matColumnDef="comment">
                  <th mat-header-cell *matHeaderCellDef>Comment</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.comment }}
                  </td>
                </ng-container>

                <!-- Categories -->
                <ng-container matColumnDef="categories">
                  <th mat-header-cell *matHeaderCellDef>Categories</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.categories }}
                  </td>
                </ng-container>

                <!-- Advisor -->
                <ng-container matColumnDef="made_by">
                  <th mat-header-cell *matHeaderCellDef>Made By</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.made_by }}
                  </td>
                </ng-container>

                <!-- Created At -->
                <ng-container matColumnDef="createdAt">
                  <th mat-header-cell *matHeaderCellDef>Created At</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.createdAt }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="action">
                  <th mat-header-cell *matHeaderCellDef>Action</th>
                  <td mat-cell *matCellDef="let element">
                    <button
                      class="delete-btn"
                      (click)="deleteComment(element.id)"
                      mat-icon-button
                      aria-label="Delete at-risk comment"
                    >
                      <mat-icon aria-hidden="false" aria-label="Delete"
                        >delete_forever
                      </mat-icon>
                    </button>
                  </td>
                </ng-container>

                <tr
                  mat-header-row
                  *matHeaderRowDef="innerDisplayedColumns"
                ></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: innerDisplayedColumns"
                ></tr>
              </table>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="outerDisplayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let element; columns: outerDisplayedColumns"
          class="example-element-row"
          [class.example-expanded-row]="expandedElement === element"
        ></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="example-detail-row"
        ></tr>
      </table>

      <mat-paginator
        [pageSizeOptions]="[10, 20, 30]"
        showFirstLastButtons
        aria-label="At-risk students table"
      >
      </mat-paginator>
    </div>
  </div>
  <ng-template #noAtRiskStudents>
    <b class="warning-note">
      No at-risk students are currently marked. Students can only be marked as
      an at-risk student from the
      <a routerLink="/student-profile">Student Profile</a> tool.
    </b>
  </ng-template>

  <back-button></back-button>
</div>
